import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles, theme } from '../style';
import { Header, Footer, Seo } from './';

const Layout = ({ page, children }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <Seo />
    {page !== 'api' && <Header />}
    {children}
    {page !== 'api' && <Footer />}
  </ThemeProvider>
);

export default Layout;
